'use client';

import { useTranslation } from '@/hooks/useTranslation';
import { rentalApi, type RentalAgreement } from '../_lib/api';
import { Badge, SimpleListPage } from '../_lib/SimpleListPage';

const STATUS_COLORS: Record<string, { bg: string; text: string }> = {
  ACTIVE: { bg: '#cffae6', text: '#00866b' },
  EXPIRED: { bg: '#f7f8fa', text: '#8f959e' },
  TERMINATED: { bg: '#ffece8', text: '#f53f3f' },
};

export default function RentalsPage() {
  const { t } = useTranslation();
  const rm = t.robotManager;
  return (
    <SimpleListPage<RentalAgreement>
      title={rm.lists.rentals.title}
      description={rm.lists.rentals.description}
      load={async (p) => (await rentalApi.list(p)).items}
      columns={[
        { key: 'id', label: 'ID', width: '120px', render: (r) => r.id.slice(0, 8) },
        { key: 'status', label: rm.fields.status, width: '120px', render: (r) => {
          const c = STATUS_COLORS[r.status] ?? { bg: '#f0f0f0', text: '#888' };
          return <Badge text={r.status} bg={c.bg} color={c.text} />;
        } },
        { key: 'startAt', label: rm.fields.rentalStart, render: (r) => new Date(r.startAt).toLocaleDateString() },
        { key: 'endAt', label: rm.fields.rentalEnd, render: (r) => new Date(r.endAt).toLocaleDateString() },
        { key: 'periodMonths', label: rm.fields.periodMonths, width: '90px' },
        { key: 'monthlyRate', label: rm.fields.monthlyRate, width: '140px', render: (r) => `${r.currencyCode} ${Number(r.monthlyRate).toLocaleString()}` },
      ]}
    />
  );
}
